import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { getDateDisplayName, getShareDisplayIcon, getShareDisplayName, getShareTooltip, } from "./utils";
import ShareOptions from "./ShareOptions";
var ShareObject = function (_a) {
    var _b;
    var object = _a.object, onDelete = _a.onDelete;
    var theme = useTheme();
    var remainingViews = (object === null || object === void 0 ? void 0 : object.max_access_count) || 0 - ((_b = object.access_count) !== null && _b !== void 0 ? _b : 0);
    var LinkIcon = getShareDisplayIcon(object);
    return (_jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 1, children: [_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [_jsx(Tooltip, { title: getShareTooltip(object), componentsProps: {
                            tooltip: {
                                sx: {
                                    paddingY: 1,
                                    paddingX: 1.5,
                                },
                            },
                        }, children: _jsx(Stack, { alignItems: "center", justifyContent: "center", width: "36px", height: "36px", sx: {
                                borderRadius: "50%",
                                backgroundColor: theme.palette.grey[100],
                            }, children: _jsx(LinkIcon, { fontSize: "small", sx: {
                                    color: theme.palette.text.primary,
                                } }) }) }), _jsxs(Stack, { children: [_jsx(Typography, { variant: "body2", sx: {
                                    width: "290px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }, children: getShareDisplayName(object) }), _jsxs(Typography, { variant: "caption", color: "textSecondary", children: [remainingViews, " view", remainingViews === 1 ? "" : "s", " until", " ", getDateDisplayName(object.expires_at)] })] })] }), _jsx(Stack, { justifySelf: "end", marginLeft: "auto", direction: "row", children: _jsx(ShareOptions, { object: object, onDelete: onDelete }) })] }));
};
export default ShareObject;
